/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseMCPCallFailedEvent = {
  type: "response.mcp_call.failed";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseMCPCallFailedEvent$inboundSchema: z.ZodType<
  ResponseMCPCallFailedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.mcp_call.failed"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseMCPCallFailedEvent$Outbound = {
  type: "response.mcp_call.failed";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseMCPCallFailedEvent$outboundSchema: z.ZodType<
  ResponseMCPCallFailedEvent$Outbound,
  z.ZodTypeDef,
  ResponseMCPCallFailedEvent
> = z.object({
  type: z.literal("response.mcp_call.failed"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseMCPCallFailedEventToJSON(
  responseMCPCallFailedEvent: ResponseMCPCallFailedEvent,
): string {
  return JSON.stringify(
    ResponseMCPCallFailedEvent$outboundSchema.parse(responseMCPCallFailedEvent),
  );
}
export function responseMCPCallFailedEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseMCPCallFailedEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseMCPCallFailedEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseMCPCallFailedEvent' from JSON`,
  );
}
